
import { reactive } from 'vue'
import { Options, Vue } from 'vue-class-component';
import { Table } from './models/table';

@Options({components: {}})
export default class App extends Vue {

	table!: Table
	selectedPiece = -1
	error = ""

	created (): void {
		this.table = reactive(new Table(8, 8, 3)) as Table
	}

	range (num: number): Array<number> {
		const nums = []
		for (let i = 0; i < num; i++) {
			nums.push(i)
		}
		return nums
	}

	putPiece (row: number, column: number): void {
		if (this.selectedPiece == -1 || this.table.isFinished)
			return
		const piece = this.table.pieces[this.selectedPiece]
		if (!this.table.isFittable(piece, row, column)) {
			this.error = "Piece does not fit"
			setTimeout(() => this.error = "", 3000)
			return
		}
		this.selectedPiece = -1
		this.table.put(piece, row, column)
	}

}
